import { useMemo } from 'react';

import { Student } from '@givebacks/api/student';

const useStudentName = (student: Student) => {
  return useMemo(() => {
    if (!student) return '';
    return `${student.first_name} ${student.last_name}`;
  }, [student]);
};

export { useStudentName };
